import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  Setting,
  CustomerSettingsContext,
  SettingsCollection,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';
import { createCustomerSettingsObject } from '../../Common/Common';

const useCustomerSettings = (
  gatewayEndPoint: string,
): [Setting[], CustomerSettingsContext, NotificationData] => {
  const [customerSettings, setCustomerSettings] = React.useState(null);
  const [customerSettingsObject, setCustomerSettingsObject] = React.useState(null);
  const [customerSettingsNotification, setCustomerSettingsNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getCustomerSettings = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      const settingsCollection: SettingsCollection = await api.settings.getCustomerSettingsV41();
      const settings: Setting[] = settingsCollection.value;

      const settings2: Setting[] = [
        {
          name: 'CustomerCustomField',
          sequenceNumber: 1,
          dataType: 'STRING',
          value: 'Custom Field 1',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 2,
          dataType: 'STRING',
          value: 'Custom Field 2',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 3,
          dataType: 'STRING',
          value: 'Custom Field 3',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 4,
          dataType: 'STRING',
          value: 'Custom Field 4',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 5,
          dataType: 'STRING',
          value: 'Custom Field 5',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 6,
          dataType: 'STRING',
          value: 'Custom Field 6',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 7,
          dataType: 'STRING',
          value: 'Custom Field 7',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 8,
          dataType: 'STRING',
          value: 'Custom Field 8',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 9,
          dataType: 'STRING',
          value: 'Custom Field 9',
          activeInd: true,
        },
        {
          name: 'CustomerCustomField',
          sequenceNumber: 10,
          dataType: 'STRING',
          value: 'Custom Field 10',
          activeInd: true,
        },
        {
          name: 'CustomerApproval',
          sequenceNumber: 1,
          dataType: 'STRING',
          value: false,
          activeInd: true,
        },
        {
          name: 'CustomerApprovalField',
          sequenceNumber: 1,
          dataType: 'STRING',
          value: 'Customer Code',
          activeInd: true,
        },
        {
          name: 'CustomerApprovalCondition',
          sequenceNumber: 1,
          dataType: 'STRING',
          value: 'Equals',
          activeInd: true,
        },
        {
          name: 'CustomerApprovalValue',
          sequenceNumber: 1,
          dataType: 'STRING',
          value: 'ABC',
          activeInd: true,
        },
      ];

      Logging.Debug('Get Customer Settings:', settings);

      // Update the Customer Settings Object
      const settingsObject: CustomerSettingsContext = createCustomerSettingsObject(settings);

      setCustomerSettings(settings);
      setCustomerSettingsObject(settingsObject);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Customer Settings Read Error',
        description: 'Unable to read Customer Settings',
        error: error as ResponseError,
      };
      setCustomerSettingsNotification(notification);
    }
  };

  React.useEffect(() => {
    if (!customerSettings) {
      dispatch(getCustomerSettings());
    }

    return (): void => {
      // This Code will run once the component unmounts.
      setCustomerSettings(null);
      setCustomerSettingsObject(null);
      setCustomerSettingsNotification(null);
    };
  }, []);

  return [customerSettings, customerSettingsObject, customerSettingsNotification];
};

export default useCustomerSettings;
